import React from 'react'
import styled from 'styled-components'
import ArrowRight from './arrow-right.svg'
import ArrowLeft from './arrow-left.svg'

export default ({
  currentDivision,
  nextName,
  prevName,
  prev,
  next
}) => (
  <Wrapper>
    <Prev onClick={() => prev()} disabled={!prevName}>{prevName}</Prev>
    <Name>{currentDivision.name}</Name>
    <Next onClick={() => next()} disabled={!nextName}>{nextName}</Next>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`

const Name = styled.h2`
  color: #3E3E3E;
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
`

const Prev = styled.button`
  background: url(${ArrowLeft});
  background-repeat: no-repeat;
  background-size: 16px 28px;
  background-position: left center;
  border: 0;
  color: #3E3E3E;
  font-size: 14px;
  font-weight: bold;
  padding-left: 25px;
  height: 28px;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    visibility: hidden;
    opacity: 0;
  `}
`

const Next = styled.button`
  background: url(${ArrowRight});
  background-repeat: no-repeat;
  background-size: 16px 28px;
  background-position: right center;
  border: 0;
  color: #3E3E3E;
  font-size: 14px;
  font-weight: bold;
  padding-right: 25px;
  height: 28px;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    visibility: hidden;
    opacity: 0;
  `}
`



// WEBPACK FOOTER //
// ./src/components/DivisionSelector/index.js